import { AesKey } from "../../config/config";
import CryptoJS from "crypto-js";

export const encryptAes = (value) => {
  var encrypted = CryptoJS.AES.encrypt(value, AesKey);
  encrypted = encrypted.toString();
  return encrypted;
};

export const decryptAes = (value) => {
  return CryptoJS.AES.decrypt(value, AesKey);
};

export const encryptAesObj = (value) => {
  console.log(value);
  return CryptoJS.AES.encrypt(JSON.stringify(value), AesKey).toString();
};

export const encryptAesObjwithTime = (value, time) => {
  return CryptoJS.AES.encrypt(JSON.stringify(value), AesKey + time).toString();
};

export const decryptAesObj = (value) => {
  // debugger
  if (!value) return false;
  var bytes = CryptoJS.AES.decrypt(value, AesKey);
  var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return decryptedData;
};

var iterationCount = 1000;
var keySize = 128;
// var encryptionKey  ="77217A25432A462D4A614E635266556A";
// var dataToDecrypt = "IlNKxC1gK/mWOSyRTR28rQ==" //The base64 encoded string output from Java;
var iv = "dc0da04af8fee58593442bf834b30739";
var salt = "dc0da04af8fee58593442bf834b30739";

var AesUtil = function (keySize, iterationCount) {
  this.keySize = keySize / 32;
  this.iterationCount = iterationCount;
};

var aesUtil = new AesUtil(keySize, iterationCount);

AesUtil.prototype.generateKey = function (salt, passPhrase) {
  var key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
    keySize: this.keySize,
    iterations: this.iterationCount,
    hasher: CryptoJS.algo.SHA1, // ← add this line only
  });
  return key;
};

AesUtil.prototype.encrypt = function (salt, iv, passPhrase, plainText) {
  var key = this.generateKey(salt, passPhrase);
  var encrypted = CryptoJS.AES.encrypt(plainText, key, {
    iv: CryptoJS.enc.Hex.parse(iv),
  });
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
};

AesUtil.prototype.decrypt = function (salt, iv, passPhrase, cipherText) {
  var key = this.generateKey(salt, passPhrase);
  var cipherParams = CryptoJS.lib.CipherParams.create({
    ciphertext: CryptoJS.enc.Base64.parse(cipherText),
  });
  var decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
    iv: CryptoJS.enc.Hex.parse(iv),
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
};

export const decryptAesObjNew = (value) => {
  if (!value) return false;
  return JSON.parse(aesUtil.decrypt(salt, iv, AesKey, value));
};
